import React from 'react';
import headerStyles from '../styles/header.module.scss'
//import Logotipo from "../../static/felixdigital.png"
 
 
const Logo = () => (
    <h3 className={headerStyles.logo} id="logo">felixdigital</h3>
    /*<div>
        <img src={`${Logotipo}`} alt="logo felix digital" className={headerStyles.logo} />
    </div>*/
);


export default Logo
